import { render, staticRenderFns } from "./ImageAttributeCore.vue?vue&type=template&id=11fa1919&scoped=true"
import script from "./ImageAttributeCore.vue?vue&type=script&lang=ts"
export * from "./ImageAttributeCore.vue?vue&type=script&lang=ts"
import style0 from "./ImageAttributeCore.vue?vue&type=style&index=0&id=11fa1919&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fa1919",
  null
  
)

export default component.exports